
export const QUICK_ACTION = 'Дія';
export const ARCHIVE = 'Архів';
